const LOAD_DETAIL_SERVICE           = 'LOAD_DETAIL_SERVICE'
const LOAD_DETAIL_SERVICE_SUCCESS   = 'LOAD_DETAIL_SERVICE_SUCCESS'
const LOAD_DETAIL_SERVICE_FAILED    = 'LOAD_DETAIL_SERVICE_FAILED'
const UNMOUNT_DETAIL_SERVICE        = 'UNMOUNT_DETAIL_SERVICE'

const initialState = {
  loading: true,
  data: null,
  message: null,
}

const serviceDetailReducer = (state = initialState, action) => {
  switch(action.type){
    case LOAD_DETAIL_SERVICE:
      return {
        ...state,
        loading: true,
        data: null,
      }
    case LOAD_DETAIL_SERVICE_SUCCESS:
      return { 
        ...state, 
        loading: false,
        data: action.payload.data,
        message: 'SUCCESS',
      }
    case LOAD_DETAIL_SERVICE_FAILED:
      return { 
        ...state, 
        loading: true,
        data: null,
        message: 'FAILED',
      }
    case UNMOUNT_DETAIL_SERVICE:
      return { 
        ...state, 
        loading: true,
        data: null,
      }
    default:
      return state
  }
}

export default serviceDetailReducer;